import { useEffect, useState } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getRoles } from '@user/store/roles/api'

export const useGetRolesOnMount = () => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(getRoles(true))
        if (mounted) {
          if (getRoles.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
          }
        }
      } catch {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return status
}
